import Vue from 'vue';
import {globalObject} from "@/utils/proxyDataUtil";
import communication from "@/store/modules/communication";
import {ViewStateType} from "@/enums/ViewStateType";
import {HTTP} from "@/utils/httpCommonUtil";

export default Vue.component('provider-communications-card', {
  name: 'ProviderCommunicationsCard',
  data () {
    return {
      provider: {} as any,
      cardExpanded: false,
      loadingInitialData: false,
      isSMS: false,
      isEmail: false,
      isShiftReminder: false,
      isBillReceipt: false,
    }
  },
  computed: {
    providerId (): string {
      return this.$route.params.providerId;
    }
  },
  async created() {
    await this.getProviderInformation()
  },
  methods: {
    expandCard () {
      this.cardExpanded = !this.cardExpanded;
    },
    async getProviderInformation() {
      try {
        const providerData = await HTTP.get('/api/providers/' + this.providerId + '/general-information')
        this.provider = {
          id: Number(this.$route.params.providerId),
          name: `${providerData.data.data.firstName} ${providerData.data.data.lastName}`,
          phoneCell: providerData.data.data.phoneCell,
          email: providerData.data.data.email
        }
        this.isSMS = providerData.data.data.receiveSMSBroadcast;
        this.isEmail = providerData.data.data.receiveEmailBroadcast;
        this.isShiftReminder = providerData.data.data.receiveShiftSchedulerEmails;
        this.isBillReceipt = providerData.data.data.receiveBillReceiptEmails;
      } catch (err) {
        this.$notify({
          group: 'main',
          type: 'error',
          title: 'Error Updating',
          text: 'An error occurred updating Provider information.'
        });
      }

    },
    async toggleCommunicationsSetting(type: string, newValue: boolean) {
      try {
        await HTTP.put('api/providers/' + this.providerId + '/communications', {type, value: newValue});
        await this.getProviderInformation();
      } catch (err) {
        this.$notify({
          group: 'main',
          type: 'error',
          title: 'Error Updating',
          text: 'An error occurred updating Provider information.'
        });
      }
    },
    async setCommunicationsDefaults() {
      globalObject.variable1 = communication;
      await this.$store.dispatch('viewState/updateViewState', {
        name: ViewStateType.COMMUNICATION_SELECTED_RECEIVER,
        value: {text:"Provider", id:1, bulletClass:"nav-circle background-blue"}
      });
      await this.$store.dispatch('viewState/updateViewState', {
        name: ViewStateType.COMMUNICATION_SELECTED_CAMPAIGN,
        value: 0
      });
      this.$router.push({name: 'Communications', params: { providerId: this.provider.id, providerName: this.provider.name }});
    },
    async goToCommunicationsTexts() {
      await this.$store.dispatch('viewState/updateViewState', {
        name: ViewStateType.COMMUNICATION_SELECTED_MESSAGE_TYPE,
        value: {text:"Texts", id:1, bulletClass:""}
      });
      await this.setCommunicationsDefaults();
    },
    async goToCommunicationsEmails() {
      await this.$store.dispatch('viewState/updateViewState', {
        name: ViewStateType.COMMUNICATION_SELECTED_MESSAGE_TYPE,
        value: {text:"Emails",id:2, bulletClass:""}
      });
      await this.setCommunicationsDefaults();
    }
  }
})



// WEBPACK FOOTER //
// ./src/components/provider/cards/communications/CommunicationsCard.ts